export const STATUS_OPTIONS = [
    { label: "All", value: "all" },
    { label: "Accepted", value: "approved" },
    { label: "Rejected", value: "rejected" },
]
